// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* QRCodeCard.css */
/* Note: Uses utilities: .text-center */

/* Caption under the QR code */
.qrcode-card__caption {
  text-align: center;
  margin-top: 0;
  padding-bottom: 0.25rem;
  color: var(--gray-800, #1E2939);
  font-size: var(--font-size-md, 1rem); /* 16px */
  font-weight: var(--font-weight-md, 500);
}

.qrcode-card {
  width: 136px;
  margin: 0 auto;
  height: auto;
  flex-shrink: 0;
}

.qrcode-card__frame {
  padding: 1rem 1rem 1.25rem 1.063rem; /* 16px 16px 20px 17px */
  border-radius: var(--border-radius-base, 0.3125rem); /* 5px */
  border: var(--border-width-thin, 0.1rem) solid var(--gray-200, #E5E7EB);
  background: var(--gray-100, #F3F4F6);
}

.qrcode-card [role="img"]:focus {
  outline: var(--border-width-medium, 2px) solid var(--color-primary, #7C4DFF);
  outline-offset: 2px;
  box-shadow: 0 0 0 2px rgba(124,77,255,0.2);
}

.qrcode-card [role="img"] {
  width: 136px;
  height: 136px;
}

.qrcode-card [role="img"] svg {
  width: 100%;
  height: 100%;
  display: block;
}`, "",{"version":3,"sources":["webpack://./node_modules/profile-pane/lib/styles/QRCodeCard.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB,uCAAuC;;AAEvC,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,+BAA+B;EAC/B,oCAAoC,EAAE,SAAS;EAC/C,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,mCAAmC,EAAE,wBAAwB;EAC7D,mDAAmD,EAAE,QAAQ;EAC7D,uEAAuE;EACvE,oCAAoC;AACtC;;AAEA;EACE,4EAA4E;EAC5E,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB","sourcesContent":["/* QRCodeCard.css */\n/* Note: Uses utilities: .text-center */\n\n/* Caption under the QR code */\n.qrcode-card__caption {\n  text-align: center;\n  margin-top: 0;\n  padding-bottom: 0.25rem;\n  color: var(--gray-800, #1E2939);\n  font-size: var(--font-size-md, 1rem); /* 16px */\n  font-weight: var(--font-weight-md, 500);\n}\n\n.qrcode-card {\n  width: 136px;\n  margin: 0 auto;\n  height: auto;\n  flex-shrink: 0;\n}\n\n.qrcode-card__frame {\n  padding: 1rem 1rem 1.25rem 1.063rem; /* 16px 16px 20px 17px */\n  border-radius: var(--border-radius-base, 0.3125rem); /* 5px */\n  border: var(--border-width-thin, 0.1rem) solid var(--gray-200, #E5E7EB);\n  background: var(--gray-100, #F3F4F6);\n}\n\n.qrcode-card [role=\"img\"]:focus {\n  outline: var(--border-width-medium, 2px) solid var(--color-primary, #7C4DFF);\n  outline-offset: 2px;\n  box-shadow: 0 0 0 2px rgba(124,77,255,0.2);\n}\n\n.qrcode-card [role=\"img\"] {\n  width: 136px;\n  height: 136px;\n}\n\n.qrcode-card [role=\"img\"] svg {\n  width: 100%;\n  height: 100%;\n  display: block;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
